// src/utils/markdownParser.js

import matter from 'gray-matter'; // For parsing frontmatter
import { marked } from 'marked'; // For parsing Markdown to HTML

/**
 * Parses a raw Markdown string containing frontmatter.
 * @param {string} markdownString - The raw string content of the .md file.
 * @returns {{ metadata: object, htmlContent: string }} An object containing the parsed frontmatter (metadata) and the HTML content.
 */
export function parseMarkdown(markdownString) {
  // Use gray-matter to separate frontmatter (data) from the body (content)
  const { data, content } = matter(markdownString);

  // Use marked to convert the Markdown body content to HTML
  // You can configure marked further here if needed (e.g., options for GFM, syntax highlighting)
  const htmlContent = marked(content);

  // Return the parsed metadata and the generated HTML content
  return {
    metadata: data,
    htmlContent: htmlContent,
  };
}

// Example of how you might use it (for your reference, not part of the file)
/*
import rawPostContent from '!!raw-loader!../blog-posts/your-first-post.md';
import { parseMarkdown } from './utils/markdownParser';

const { metadata, htmlContent } = parseMarkdown(rawPostContent);

console.log(metadata.title); // Outputs: "Your First Blog Post Title"
console.log(htmlContent); // Outputs: "<p>Welcome to your first blog post...</p>"
*/